<template>
	<div class="Done">
		<div v-if="sent">
			<div v-if="resultOk">
				<div class="areaContainingImage">
					<div class="roundImage">
						<img src="../assets/illustration6.svg" />
					</div>
				</div>
				<h2>{{ lang.signup.done.header }}</h2>
				<p
					v-html="
						lang.signup.done.introText.replace(
							'{0}',
							`<span class='partner-signup-done-email-inject'>${email}</span>`
						)
					"
				></p>
				<p>{{ lang.signup.done.introText2 }}</p>

				<div class="nextPageControls">
					<a :href="lang.common.helpCenterLink" target="_blank">
						<Button class="white">{{ lang.signup.done.seeTipsLinkText }}</Button>
					</a>
					<a :href="lang.common.partnerGuideLink" target="_blank">
						<Button class="white">{{ lang.signup.done.seeGuideLinkText }}</Button>
					</a>
				</div>
			</div>
			<div v-else>
				<!-- Oh no! -->
				<div class="errorMessage">{{ errorMessage }}</div>

				<div class="nextPageControls">
					<Button class="onlyText" @click="$router.push('location')">{{
						lang.signup.button.back
					}}</Button>
					<Button class="white" @click="startOver">{{ lang.signup.done.startOver }}</Button>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="loader">Loading...</div>
		</div>
	</div>
</template>

<script>
import lang from '../lang'
import Button from '../components/Button'
import { mapActions } from 'vuex'
import { signUp } from '../util/ajax'
import { getCountryObject } from '../util/env'

function validateState(state) {
	if (!state.country) {
		// TODO: handle this in better way
		throw new Error('Country missing. Perhaps you already signed up your restaurant?')
	}
}

export default {
	name: 'Done',
	props: [],
	data() {
		return {
			lang,
			sent: false,
			resultOk: false,
			errorMessage: '',
			email: this.$store.state.email,
		}
	},
	computed: {},
	methods: {
		...mapActions(['clearAll']),
		startOver() {
			this.clearAll()
			this.$router.push('/')
			location.reload()
		},
	},
	components: {
		Button,
	},
	async mounted() {
		// TODO: validate stuff and then send them to the server
		let state = this.$store.state

		try {
			validateState(state)
		} catch (e) {
			this.errorMessage = e.message
			this.sent = true
			this.resultOk = false
			return
		}

		let countryObject = getCountryObject(state.country)
		let countryId = countryObject.id

		if (countryId === 'ala') {
			countryId = 'fin'
		}

		const venueType = state.type
		let defaultOfferType = 'meal'

		switch (venueType) {
		case 'cafe':
			defaultOfferType = 'snack'
			break
		case 'groceryStore':
			defaultOfferType = 'grocery-bag'
			break
		case 'flowerStore':
			defaultOfferType = 'flowers'
			break
		}

		let data = {
			address: state.address, // "Leppämäentie 64"
			country: countryId, // "fin"
			defaultOfferType, // "snack"
			monFetchStart: state.monFetchStart, // "19:00:00"
			tueFetchStart: state.tueFetchStart,
			wedFetchStart: state.wedFetchStart,
			thuFetchStart: state.thuFetchStart,
			friFetchStart: state.friFetchStart,
			satFetchStart: state.satFetchStart,
			sunFetchStart: state.sunFetchStart,
			monFetchEnd: state.monFetchEnd,
			tueFetchEnd: state.tueFetchEnd,
			wedFetchEnd: state.wedFetchEnd,
			thuFetchEnd: state.thuFetchEnd,
			friFetchEnd: state.friFetchEnd,
			satFetchEnd: state.satFetchEnd,
			sunFetchEnd: state.sunFetchEnd,
			description: state.description, // "434"
			email: state.email, // "marko.rintamaki@gmail.com"
			locationCity: state.city, // "Eriksnäs"
			latitude: state.latitude, // 60.4782085
			longitude: state.longitude, // 22.6543908
			postalCode: state.postalCode, // 00180
			name: state.name, // "Egget Oy"
			password: state.password, // "ergergrg"
			publicPhoneNumber: state.phone, // "+123 123 456"
			responsiblePersonName: state.contactName,
			preferredLanguageCode: state.preferredLanguageCode,
			username: state.username, // "egget-oy-eriksnas"
			venueType, // "cafe"
			website: state.website, // "https://tuorepasta.fi/"
			googleVenueId: state.googleVenueId,
			invoiceBusinessID: state.vatNumber,
		}

		try {
			await signUp(data)

			this.sent = true
			this.resultOk = true

			this.clearAll()
		} catch (error) {
			this.errorMessage = error.message
			this.sent = true
			this.resultOk = false
		}
	},
}
</script>

<style lang="stylus">
.partner-signup-done-email-inject {
	font-weight: bold;
}
</style>
<style lang="stylus" scoped>
.Done {
	text-align: center;
}

.areaContainingImage {
	padding: 40px;
	text-align: center;

	.roundImage {
		display: inline-block;
		width: 100px;
		height: 100px;
		text-align: center;
		overflow: hidden;
		background: #00cfab;
		border-radius: 50%;

		img {
			position: relative;
			left: 4px;
			height: 180px;
			margin-top: 10px;
		}
	}
}
.partner-signup-done-email-inject {
	font-weight: bold;
}
.errorMessage {
	color: red;
}


// Spinner from the internet:

.loader {
  font-size: 10px;
  margin: 50px auto;
  text-indent: -9999em;
  width: 11em;
  height: 11em;
  border-radius: 50%;
  background: #1bcbac;
  background: -moz-linear-gradient(left, #1bcbac 10%, rgba(255, 255, 255, 0) 42%);
  background: -webkit-linear-gradient(left, #1bcbac 10%, rgba(255, 255, 255, 0) 42%);
  background: -o-linear-gradient(left, #1bcbac 10%, rgba(255, 255, 255, 0) 42%);
  background: -ms-linear-gradient(left, #1bcbac 10%, rgba(255, 255, 255, 0) 42%);
  background: linear-gradient(to right, #1bcbac 10%, rgba(255, 255, 255, 0) 42%);
  position: relative;
  -webkit-animation: load3 1.4s infinite linear;
  animation: load3 1.4s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  overflow: hidden;
}
.loader:before {
  width: 50%;
  height: 50%;
  background: #1bcbac;
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: '';
}
.loader:after {
  background: white;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: '';
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
@-webkit-keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
